
export function ViewBox({title,children,width="w-full"}){
    return <div className={`flex flex-col p-4 bg-white rounded-lg grow gap-2 ${width}`}>
        <div className="flex bg-[#DBDEFFFC] rounded h-[40px] items-center">
            <p className="flex text-blue-dark font-bold pl-[12px]">{title}</p>
        </div>
        <div>
            {children}
        </div>
    </div>
}